export const pt: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'Painel de Controle',
  'nav.focus': 'Foco Diário e Roteiro',
  'nav.ai_assistant': 'Motor Operacional Automatizado',
  'nav.calendar': 'Google Agenda',
  'nav.book': 'Página Pública de Agendamento',
  'nav.bookings': 'Agendamentos e Receitas',
  'nav.invoices': 'Faturas',
  'nav.expenses': 'Despesas',
  'nav.settings': 'QG Comercial e Tributário',
  'nav.billing': 'Assinatura e Planos',
  'nav.j_lens': 'Cofre J-Lens',
  'nav.concept': 'Conceito e Filosofia',
  'nav.what_is': 'O que é o AzuraOS?',
  'nav.export': 'Exportar e Backup',
  'nav.menu': 'Menu',
  'nav.welcome': 'Boas-vindas e Hub BYOK',
  'nav.app_stack_modules': 'Módulos do Sistema',
  'nav.core_engines': '8 Motores Principais',
  'nav.manifesto': 'Sistema e Manifesto dos Fundadores',
  'nav.workspace_actions': 'Ações do Espaço',
  'nav.export_records': 'Exportar Registros',
  'nav.load_demo': 'Carregar Dados Demo',
  'nav.partnerships': 'Parcerias e Apoio',
  'nav.request_partnership': 'Solicitar Acesso de Parceiro',
  'nav.partner_subtext': 'Integrações bancárias, turmas e patrocínios',
  'nav.interface_language': 'Idioma da Interface',
  'nav.legal_trust': 'Legal e Confiança',
  'nav.security': 'Segurança',
  'nav.faqs': 'Perguntas Frequentes',
  'nav.terms': 'Termos',
  'nav.privacy': 'Privacidade',
  'nav.refund': 'Política de Reembolso',
  'nav.contact': 'Contato',
  'nav.report_bug': 'Reportar Erro',
  'nav.invite_founder': '+ Convidar Fundador',
  'nav.privacy_active': 'Modo Privacidade: ATIVO',
  'nav.privacy_off': 'Modo Privacidade: DESATIVADO',
  'nav.masked': 'Oculto',
  'nav.visible': 'Visível',
  'nav.live_margin': 'MARGEM OPERACIONAL EM TEMPO REAL',
  'nav.target_safe_zone': 'Alvo de Margem Segura:',
  'nav.close_menu': 'Fechar Menu',
  'nav.founder_access': 'Entrar / Acesso Fundador',
  'nav.private_vault': 'Cofre Privado Conectado',
  'nav.master_access': 'Acesso Master do Fundador',
  'nav.lifetime': 'Vitalício',
  'nav.pro_active': 'Soberano Pro Ativo',
  'nav.trial_days': 'Teste 7 Dias: {days} dias restantes',
  'nav.trial_expired': 'Teste Expirado',
  'nav.manage': 'Gerenciar →',
  'nav.upgrade': 'Fazer Upgrade →',
  'nav.unlock_pro': 'Desbloquear Pro →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'Bom dia',
  'dash.greeting_afternoon': 'Boa tarde',
  'dash.greeting_evening': 'Boa noite',
  'dash.value_prop': 'Controle de múltiplos fluxos em um só lugar: insira 1 receita e 1 despesa para ver sua margem líquida em tempo real.',
  'dash.manage_streams': 'Gerenciar Fontes de Receita',
  'dash.close_streams': 'Fechar Fontes',
  'dash.income': 'Receitas',
  'dash.collected': 'Recebido',
  'dash.unpaid': 'Pendente',
  'dash.expenses': 'Despesas',
  'dash.across_records': 'Nos registros',
  'dash.net_profit': 'Lucro Líquido',
  'dash.daily_focus_title': 'Foco Diário e Plano de Receita',
  'dash.daily_focus_sub': 'Tarefas estratégicas de alto impacto para aumentar os lucros',
  'dash.open_focus': 'Abrir Roteiro de Foco',
  'dash.stream_profitability': 'Rentabilidade por Fonte',
  'dash.stream_sub': '1 oferta ou múltiplos serviços • Margem em tempo real',
  'dash.quick_actions': 'Ações Rápidas',
  'dash.add_booking': 'Novo Agendamento',
  'dash.add_booking_desc': 'Registrar nova receita de cliente',
  'dash.add_expense': 'Registrar Despesa',
  'dash.add_expense_desc': 'Lançar custos operacionais e comerciais',
  'dash.add_insight': 'Adicionar Insight',
  'dash.add_insight_desc': 'Criar nova regra J-Lens',
  'dash.quick_add_title': 'Entrada Rápida',
  'dash.quick_revenue': '+ RECEITA RÁPIDA (AGENDAMENTO)',
  'dash.quick_expense': '+ DESPESA RÁPIDA (LIVRO CAIXA)',
  'dash.recent_activity': 'Atividade Recente',
  'dash.no_activity': 'Nenhuma atividade recente. Use as ações rápidas acima para iniciar.',
  'dash.spotlight_insight': 'Insight em Destaque J-Lens',
  'dash.access_vault': 'Acessar Cofre →',
  'dash.sandbox_active': 'Modo Demonstração Ativo',
  'dash.load_demo_data': 'Carregar Dados Demo',
  'dash.clear_sandbox': 'Limpar Dados Demo',
  'dash.clear_confirm': 'Deseja limpar os dados?',
  'dash.yes_clear': 'Sim, limpar',
  'dash.cancel': 'Cancelar',

  // Bookings View
  'bookings.title': '📅 Agendamentos e Fontes',
  'bookings.subtitle': 'Canais soberanos de receita de clientes',
  'bookings.public_page': 'Página Pública de Agendamento',
  'bookings.import_csv': 'Importar CSV',
  'bookings.add_button': 'Novo Agendamento',
  'bookings.client_link_title': 'Link de Autoagendamento do Cliente',
  'bookings.client_link_desc': 'Compartilhe links com preços padrão ou personalizados para agendamento automático e sincronização com Google Agenda.',
  'bookings.link_active': 'Ativo',
  'bookings.generate_custom_link': '⚡ Gerar Link Personalizado',
  'bookings.hide_custom_link': 'Ocultar Link',
  'bookings.copy_standard_link': 'Copiar Link Padrão',
  'bookings.copied_link': 'Link copiado!',
  'bookings.preview': 'Visualizar',
  'bookings.search_placeholder': 'Buscar por cliente ou serviço...',
  'bookings.filter_all': 'Todas as Fontes',
  'bookings.table_client': 'Nome do Cliente',
  'bookings.table_stream': 'Serviço / Fonte',
  'bookings.table_date': 'Data',
  'bookings.table_amount': 'Valor',
  'bookings.table_status': 'Status',
  'bookings.table_actions': 'Ações',
  'bookings.mark_paid': 'Marcar como Pago',
  'bookings.mark_unpaid': 'Marcar Pendente',
  'bookings.delete': 'Excluir',
  'bookings.no_records': 'Nenhum agendamento encontrado. Use "Novo Agendamento" acima.',

  // Invoices View
  'invoices.title': '📄 Faturas e Contas a Receber',
  'invoices.subtitle': 'Faturamento profissional e conciliação de recebimentos',
  'invoices.create_invoice': 'Criar Nova Fatura',
  'invoices.tab_all': 'Todas as Faturas',
  'invoices.tab_paid': 'Faturas Pagas',
  'invoices.tab_outstanding': 'Pendentes / Em Aberto',
  'invoices.tab_overdue': 'Vencidas',
  'invoices.table_number': 'Nº Fatura',
  'invoices.table_client': 'Cliente',
  'invoices.table_issue_date': 'Data de Emissão',
  'invoices.table_due_date': 'Data de Vencimento',
  'invoices.table_total': 'Valor Total',
  'invoices.table_status': 'Status',
  'invoices.download_pdf': 'Baixar PDF',
  'invoices.mark_as_paid': 'Marcar Pago',
  'invoices.no_records': 'Nenhuma fatura gerada. Crie uma para gerenciar recebíveis.',

  // Expenses View
  'expenses.title': '💳 Despesas Comerciais e Livro Caixa',
  'expenses.subtitle': 'Acompanhamento de saídas e otimização de deduções fiscais',
  'expenses.log_expense': 'Registrar Despesa',
  'expenses.import_csv': 'Importar CSV',
  'expenses.total_outflow': 'Despesas Totais',
  'expenses.tax_deductible': 'Dedutível de Impostos',
  'expenses.search_placeholder': 'Buscar por fornecedor ou descrição...',
  'expenses.filter_all': 'Todas as Categorias',
  'expenses.table_category': 'Categoria',
  'expenses.table_description': 'Descrição / Fornecedor',
  'expenses.table_date': 'Data',
  'expenses.table_claimable': 'Dedutível',
  'expenses.table_amount': 'Valor',
  'expenses.table_actions': 'Ações',
  'expenses.claimable_yes': 'Sim (Dedutível)',
  'expenses.claimable_no': 'Não (Pessoal / Não dedutível)',
  'expenses.no_records': 'Nenhuma despesa registrada. Adicione seus custos para calcular a margem real.',

  // Daily Focus & Roadmap
  'focus.title': '🎯 Foco Diário e Plano de Ação',
  'focus.subtitle': 'Tarefas estratégicas para impulsionar fluxo de caixa e rentabilidade',
  'focus.add_task': 'Adicionar Tarefa de Receita',
  'focus.active_tasks': 'Tarefas Prioritárias Ativas',
  'focus.completed_tasks': 'Tarefas Concluídas',
  'focus.high_leverage': 'Alto Impacto',
  'focus.mark_done': 'Concluir',
  'focus.delete_task': 'Excluir',
  'focus.no_tasks': 'Tudo em dia! Adicione uma tarefa estratégica para manter o ritmo.',

  // Automated Operational Engine
  'ai.title': '⚡ Motor Operacional Automatizado',
  'ai.subtitle': 'Cálculos criptografados no navegador e inteligência financeira soberana (Sem retenção de dados)',
  'ai.ask_placeholder': 'Pergunte sobre fluxo de caixa, margens ou estratégias de preços...',
  'ai.send': 'Analisar',
  'ai.thinking': 'O motor operacional está processando seus cálculos...',
  'ai.prompt_margin': 'Como posso aumentar minha margem de lucro líquido para 60%?',
  'ai.prompt_tax': 'Quais despesas deduzir para otimizar minha reserva tributária?',
  'ai.prompt_pricing': 'Como devo estruturar meus pacotes mensais de consultoria?',
  'ai.clear_chat': 'Limpar Histórico',

  // Business & Tax HQ
  'hq.title': '🏢 QG Comercial e Tributário',
  'hq.subtitle': 'Perfil, moeda, regras tributárias, predefinições regionais e auditoria contábil',
  'hq.tab_profile': 'Perfil e Identidade',
  'hq.tab_currency_tax': 'Regras de Moeda e Impostos',
  'hq.tab_accountant_view': 'Visão do Contador e Auditoria CPA',
  'hq.tab_exports': 'Exportações e Backups',
  'hq.tab_security': 'Segurança e Proteção',
  'hq.jurisdiction_preset_title': 'Predefinição de Jurisdição Regional',
  'hq.jurisdiction_preset_desc': 'Selecione seu país para configurar automaticamente a moeda, alíquotas de imposto e órgãos tributários.',
  'hq.accountant_view_title': 'Visão do Contador e Auditoria CPA',
  'hq.accountant_view_desc': 'Relatório pré-contábil padronizado pronto para contadores externos ou análise bancária.',
  'hq.export_pdf_audit': 'Relatório de Auditoria em PDF',
  'hq.export_csv_audit': 'Exportar CSV de Auditoria',
  'hq.currency_symbol': 'Símbolo da Moeda',
  'hq.currency_code': 'Código da Moeda',
  'hq.vat_rate': 'Alíquota de Imposto / IVA (%)',
  'hq.tax_authority': 'Nome da Autoridade Tributária',
  'hq.save_settings': 'Salvar Configurações',

  // Financial & Metric Labels
  'metric.gross_revenue': 'Receita Bruta',
  'metric.total_expenses': 'Despesas Totais',
  'metric.net_profit': 'Resultado Operacional Líquido',
  'metric.profit_margin': 'Margem de Lucro Operacional',
  'metric.active_bookings': 'Agendamentos Ativos',
  'metric.paid_invoices': 'Faturas Pagas',
  'metric.unpaid_invoices': 'Faturas Pendentes',
  'metric.tax_buffer': 'Reserva Fiscal Estimada',
  'metric.currency': 'Moeda Operacional',
  'metric.tax_rate': 'Alíquota de Imposto',

  // Actions & Common Buttons
  'btn.save': 'Salvar Alterações',
  'btn.cancel': 'Cancelar',
  'btn.download': 'Baixar',
  'btn.export_pdf': 'Baixar Relatório em PDF',
  'btn.export_csv': 'Exportar como CSV',
  'btn.cpa_pack': 'Exportar Pacote do Contador',
  'btn.new_booking': 'Registrar Agendamento',
  'btn.new_expense': 'Registrar Despesa',
  'btn.add_task': 'Adicionar Tarefa',
  'btn.sync_calendar': 'Sincronizar Google Agenda',
  'btn.privacy_mode': 'Modo Privacidade',
  'btn.manage_subscription': 'Gerenciar Assinatura',
  'btn.sign_in': 'Entrar / Acesso',
  'btn.sign_out': 'Sair',
  'btn.delete': 'Excluir',
  'btn.edit': 'Editar',
  'btn.close': 'Fechar',

  // Statuses
  'status.paid': 'Pago',
  'status.unpaid': 'Pendente',
  'status.overdue': 'Vencido',
  'status.safe': 'Margem Saudável',
  'status.warning': 'Alerta de Margem',
  'status.trial_active': 'Teste Grátis Ativo',
  'status.pro_active': 'Soberano Pro',
};
